/**
 * CommentUpload
 */

import Config from '../../Config';
import Util from '../../Util';
import Toast from '../../Toast';
import Template from '../Template';

interface IUploadData {
  isGetTokenOnInit: boolean;
  createToken?: string;
  tokenFileInfo?: string;
  // callbackName?: string;
}

class CommentUpload {
  public onUploaded: any;

  public onUploadBefore: any;

  private commentUpload: any;

  constructor() {
    this.onUploaded = new Util.Observer();
    this.onUploadBefore = new Util.Observer();
    this.init();
  }

  public template(url: string) {
    return `<img src="${url}" class="comment-image" alt=""/>`;
  }

  public addEventFrameload() {
    jQuery('iframe.comment-upload')
      .off()
      .on('load', evt => {
        evt.preventDefault();
        const $this = jQuery(evt.target);

        $this
          .contents()
          .off()
          .on('click', contentEvt => {
            const commentId = $this.parents('div.comment-article').attr('data-commentid');
            this.onUploadBefore.emit(commentId);
          });
      });
  }

  public resetUploadFrame() {
    const $frame = jQuery('iframe.comment-upload') as any;
    const _$body = jQuery('body');

    $frame.each((idx: number, frame: any) => {
      const $this = jQuery(frame);
      const url = $this.attr('src');
      // const referrer = document.referrer;
      frame.contentDocument.location.replace(url);
      // if (navigator.userAgent.toLocaleLowerCase().indexOf('chrome') !== -1 && _$body.hasClass( 'pc' )) {
      //   window.history.go(-1);
      // }
    });
  }

  public init() {
    const win = window as any;
    if (win.ui && win.ui.ncUpload) {
      const uploadData: IUploadData = {
        isGetTokenOnInit: false,
        // callbackName: 'ass',
      };

      if (Config.commentUploadTokenUrl) {
        uploadData.createToken = Config.commentUploadTokenUrl;
      }

      if (Config.commentTokenFileInfoUrl) {
        uploadData.tokenFileInfo = Config.commentTokenFileInfoUrl;
      }

      this.commentUpload = new win.ui.ncUpload(uploadData);

      this.commentUpload.onComplete.add((_data: any) => {
        const _images = _data.images;
        const _url = _images[_images.length - 1];
        this.onUploaded.emit(this.template(_url));
        this.resetUploadFrame();
      }, this);

      this.commentUpload.onUploading.add(() => {
        const _$body = jQuery('body');

        if (_$body.hasClass('mobile') || _$body.hasClass('tablet')) {
          Toast.show(Config.L10N.comment_image_upload);
        }
      });
    }
  }
}

export default CommentUpload;
